import { render, staticRenderFns } from "./AsignarEquipoInspector.vue?vue&type=template&id=74c70b5b&"
import script from "./AsignarEquipoInspector.vue?vue&type=script&lang=js&"
export * from "./AsignarEquipoInspector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports